import { memo } from 'react';
import { StyledPageHeader } from '@/app/shared-components/Common/Styled/StyledPageHeader.styled';
import Breadcrumb from '@/app/shared-components/BreadCrumbs/BreadCrumbs';

interface RouteForBreadcrumbsTypes {
  path: string;
  breadcrumbName: string;
}
const routes: RouteForBreadcrumbsTypes[] = [
  { path: '/users', breadcrumbName: 'Users' },
  { path: '/users/add', breadcrumbName: 'Add User' },
];

const Header = () => {
  return (
    <StyledPageHeader>
      <Breadcrumb routes={routes} />
    </StyledPageHeader>
  );
};
export default memo(Header);
